export default __webpack_public_path__ + "static/media/thumb_17.ca134ff4.webp";